import React from 'react';

const Contact = () => {
      return (
            <div>
                  <a href="http://github.com/iamraufu">Follow me on GitHub</a>
            </div>
      );
};

export default Contact;